import { useEffect } from "react";

const BASE = "Mumbai Elite Diagnostics";
const HOME_TITLE = "Mumbai Elite Diagnostics | Best Pathology Lab & FNAC Centre in Gwalior";

export const usePageTitle = (page) => {
  useEffect(() => {
    document.title = page ? `${page} · ${BASE}` : HOME_TITLE;
  }, [page]);
};

export default usePageTitle;
